import {Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {AppConfigService} from '../../../../services/app.config.service';
import {UserVO} from '../../../../generate/UserVO';

@Component({
    selector: 'app-user-profile-view',
    templateUrl: './user-profile-view.component.html',
    styleUrls: ['./user-profile-view.component.scss'],
    standalone: false
})
export class UserProfileViewComponent implements OnChanges {

  @Input()
  user: UserVO ;

  @Output()
  editEnabled = new EventEmitter<void>();

  constructor(private appConfigService: AppConfigService) {
  }

  onEdit() {
    this.editEnabled.emit();
  }

  isTldManagerProfile() {
    return this.appConfigService.isTldManagerInterface() || (this.appConfigService.isStaffInterface() && this.user.roles.filter(role => role === 'TLD_MANAGER').length > 0);
  }

  ngOnChanges(changes: any): void {
  }
}
